// TableDigiUpload.jsx

import React from "react";

// Separate component for rendering table header
const TableHeader = ({ headers }) => (
  <thead style={{ background: "#F2F5F7" }}>
    <tr>
      {headers.map((header, index) => (
        <th key={index} scope="col">
          {header}
        </th>
      ))}
    </tr>
  </thead>
);

// Separate component for rendering table body rows
const TableBody = ({ data }) => (
  <tbody>
    {data.map((row, index) => (
      <tr key={index}>
        {row.map((cell, index) => (
          <td key={index}>{cell}</td>
        ))}
      </tr>
    ))}
  </tbody>
);

// Main TableDigiUpload component
function TableDigiUpload({ headers, data }) {
  return (
    <table className="col-12 pb-4 table">
      <TableHeader headers={headers} />
      <TableBody data={data} />
    </table>
  );
}

export default TableDigiUpload;
